import { render, staticRenderFns } from "./instructor_files.vue?vue&type=template&id=00e24188&scoped=true&"
import script from "./instructor_files.vue?vue&type=script&lang=ts&"
export * from "./instructor_files.vue?vue&type=script&lang=ts&"
import style0 from "./instructor_files.vue?vue&type=style&index=0&id=00e24188&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e24188",
  null
  
)

export default component.exports